import { render, staticRenderFns } from "./FormLayoutSection.vue?vue&type=template&id=6e520395&scoped=true&"
import script from "./FormLayoutSection.vue?vue&type=script&lang=js&"
export * from "./FormLayoutSection.vue?vue&type=script&lang=js&"
import style0 from "./FormLayoutSection.vue?vue&type=style&index=0&id=6e520395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e520395",
  null
  
)

export default component.exports